import React from "react";

import { Props } from "./types";
import { Image } from "./image";
import styles from "./styles.scss";

function hashCode(str: string) {
  let hash = 0;

  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  return hash;
}

function intToRGB(i: number) {
  const c = (i & 0x00ffffff).toString(16).toUpperCase();

  return "00000".substring(0, 6 - c.length) + c;
}

function isColorLight(color: string) {
  const hex = color.replace("#", "");
  const c_r = parseInt(hex.substring(0, 2), 16);
  const c_g = parseInt(hex.substring(2, 2 + 2), 16);
  const c_b = parseInt(hex.substring(4, 4 + 2), 16);
  const brightness = (c_r * 299 + c_g * 587 + c_b * 114) / 1000;

  return brightness > 155;
}

function MemberAvatar(props: Props) {
  const initials = props.name
    .split(" ")
    .map((name) => name[0])
    .join("")
    .toUpperCase();
  const color = props.color
    ? props.color
    : `#${intToRGB(hashCode(props.name))}`;

  return props.avatarUrl ? (
    <Image
      className={styles.zoneAvatar}
      src={props.avatarUrl}
      fallBack={
        <svg
          viewBox="0 0 18 26"
          className={styles.zoneAvatar}
          style={{
            backgroundColor: color,
            fill: isColorLight(color) ? "#000000" : "#FFFFFF",
          }}
        >
          <text x="9" y="18" fontWeight="600" fontSize="14" textAnchor="middle">
            {initials}
          </text>
        </svg>
      }
    />
  ) : (
    <svg
      viewBox="0 0 18 26"
      className={styles.zoneAvatar}
      style={{
        backgroundColor: color,
        fill: isColorLight(color) ? "#000000" : "#FFFFFF",
      }}
    >
      <text x="9" y="18" fontWeight="600" fontSize="14" textAnchor="middle">
        {initials}
      </text>
    </svg>
  );
}

export { MemberAvatar };
